<app-page-shell>
  <p-toast></p-toast>

  <app-page-hero eyebrow="CRM Quotations" title="Quotation Templates" subtitle="Maintain default descriptions and terms by job type. New quotations copy these defaults and can override them.">
    <div actions>
      <p-button label="Back to Quotations" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/crm/quotations"></p-button>
      <p-button label="New Template" icon="pi pi-plus" severity="secondary" [outlined]="true" (click)="reset()"></p-button>
      <p-button label="Save Template" icon="pi pi-save" (click)="save()"></p-button>
    </div>
  </app-page-hero>

  <app-page-form-section icon="pi pi-file-edit" title="Template Editor" subtitle="Configure the reusable quotation description and rich text terms for a job type.">
    <form [formGroup]="form" class="terms-form p-fluid">
      <div class="form-row">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="jobType" formControlName="jobType" [options]="jobTypeOptions" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
            <label for="jobType">Job Type *</label>
          </p-iftaLabel>
        </p-inputGroup>
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-file-edit"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="title" pInputText formControlName="title">
            <label for="title">Template Title *</label>
          </p-iftaLabel>
        </p-inputGroup>
        <label class="active-toggle">
          <p-checkbox formControlName="active" [binary]="true"></p-checkbox>
          <span>Active</span>
        </label>
      </div>
      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-align-left"></i></p-inputGroupAddon>
        <p-iftaLabel>
          <textarea id="description" pTextarea rows="4" formControlName="description"></textarea>
          <label for="description">Default Description</label>
        </p-iftaLabel>
      </p-inputGroup>
      <p-editor formControlName="termsHtml" [style]="{ height: '320px' }"></p-editor>
    </form>
  </app-page-form-section>

  <app-page-data-panel title="Configured Templates" subtitle="Tenant quotation defaults" [resultText]="templates().length + ' templates'">
    <p-table [value]="templates()" [loading]="loading()" styleClass="p-datatable-sm p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Job Type</th>
          <th>Title</th>
          <th>Description</th>
          <th>Status</th>
          <th class="text-center" style="width: 8rem">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-template>
        <tr>
          <td>{{ template.jobType }}</td>
          <td>{{ template.title || '-' }}</td>
          <td>{{ template.description || '-' }}</td>
          <td>{{ template.active === false ? 'Inactive' : 'Active' }}</td>
          <td class="text-center">
            <p-button icon="pi pi-pencil" [text]="true" severity="secondary" (click)="edit(template)"></p-button>
            <p-button icon="pi pi-trash" [text]="true" severity="danger" (click)="delete(template)"></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="5">No quotation templates configured.</td></tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
